/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { userInformationStyles } from "@monsma/Overrides/Widgets/AccountSettings/AccountSettingsUserInformation";
import { css } from "styled-components";

userInformationStyles.changePasswordLink = {
    css: css`
        margin-left: 10px;

        ${getProp("theme.link.defaultProps.css")};

        ${TypographyStyle} {
            font-size: 10px;
            line-height: 16px;
        }
    `,
};

(userInformationStyles as any).container = { gap: 20 };

(userInformationStyles as any).passwordLabelWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};
